const generatedIds = [];
const uidLength = 20;
const makeid = function (length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const generateUID = function () {
  let newId;
  do {
    newId = makeid(uidLength);
  } while (generatedIds.includes(newId));

  generatedIds.push(newId);
  return newId;
};
